import client from "../config/axiosConfig";

export const getChatAuthApi = () => client.get("/chat/token");
